/* ------------------------------------------------------------------------------
@name: DatePickerInput
@description: DatePickerInput Activate
--------------------------------------------------------------------------------- */

// --- DatePickerInput
const DatePickerInput = (() => {
  const handlRunDatePicker = () => {
    const $date = $(".js-datepicker");

    $date.datepicker("destroy");

    $date.datepicker({
      format: "dd/mm/yy",
      autoclose: true,
      todayHighlight: true,
    });

    // set default date
    $(".js-datepicker").val(moment().format("D/MM/YYYY"));

    $date.on("change blur", function () {
      const val = $(this).val();
      const fixed = moment(val, ["MM/DD/YYYY", "DD/MM/YYYY"]).format(
        "DD/MM/YYYY"
      );
      $(this).val(fixed);
    });
  };

  const handlRunDatePickerDepature = () => {
    const $date = $(".js-datepicker-depature");

    $date.datepicker({
      format: "dd/mm/yy",
      autoclose: true,
      todayHighlight: true,
    });

    $date.on("change blur", function () {
      const val = $(this).val();
      const fixed = moment(val, ["MM/DD/YYYY", "DD/MM/YYYY"]).format(
        "DD/MM/YYYY"
      );
      $(this).val(fixed);
    });
  };

  const handleTimePicker = () => {
    $(".js-timepicker").timepicker({
      showMeridian: false,
      icons: {
        up: "mdi mdi-chevron-up",
        down: "mdi mdi-chevron-down",
      },
    });
  };

  // handldeDateRengePicker
  const handleDateRangePicker = () => {
    let _days = 29;

    if ($(".js-date-range-picker").attr("data-range") !== undefined) {
      _days = parseInt($(".js-date-range-picker").attr("data-range"));
    }

    const start = moment().subtract(_days, "days");
    const end = moment();

    const cb = (start, end) => {
      $(".js-date-range-picker")
        .val(start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY"))
        // ✅ store clean format (NO parsing needed later)
        .attr("data-start", start.format("YYYY-MM-DD"))
        .attr("data-end", end.format("YYYY-MM-DD"))
        .trigger("change"); // ✅ trigger reload
    };

    $(".js-date-range-picker").daterangepicker(
      {
        startDate: start,
        endDate: end,
        locale: {
          format: "DD/MM/YYYY",
          separator: " - ",
        },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days"),
          ],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
          "This Year": [moment().startOf("year"), moment().endOf("year")],
          "Last Year": [
            moment().subtract(1, "year").startOf("year"),
            moment().subtract(1, "year").endOf("year"),
          ],
        },
      },
      cb
    );

    // ✅ set default value immediately
    cb(start, end);
  };

  const init = () => {
    if (
      $(".js-datepicker").length ||
      $(".js-date-range-picker").length ||
      $(".js-timepicker").length
    ) {
      handlRunDatePickerDepature();
      handlRunDatePicker();
      handleDateRangePicker();
      handleTimePicker();
    }
  };

  // --- return
  return {
    init,
  };
})();

export default DatePickerInput;
